module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isPosMeioDia) ? _c('button', {
    staticClass: "btn btn-xs font-bold",
    class: {
      'btn-danger': _vm.isRegraMeioDiaAtivada, 'btn-dark': !_vm.isRegraMeioDiaAtivada
    },
    on: {
      "click": _vm.alterarRegraMeioDia
    }
  }, [_vm._v("\n  " + _vm._s(_vm.isRegraMeioDiaAtivada ? 'Desativar' : 'Ativar') + " regra meio-dia\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1759c79f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/BtnAlterarRegraMeioDia.vue
// module id = 1525
// module chunks = 17